const STORAGE_KEY = 'userFavorites';

export function getFavorites() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; }
}

function save(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent('favoritesChanged'));
}

/** Add the item if absent, remove it if already present. Returns true if now favorited. */
export function toggleFavorite(item) {
  const list = getFavorites();
  const idx = list.findIndex((f) => f.id === item.id && f.type === item.type);
  const next = idx >= 0 ? list.filter((_, i) => i !== idx) : [item, ...list];
  save(next);
  return idx < 0;
}

export function removeFavorite(id, type) {
  save(getFavorites().filter((f) => !(f.id === id && f.type === type)));
}

export function isFavorite(id, type) {
  return getFavorites().some((f) => f.id === id && f.type === type);
}

export function clearFavorites() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent('favoritesChanged'));
}
